export default __webpack_public_path__ + "static/media/electricity.d883a889.jpg";